export class Usuario {

    public id: string;
    public codigo: number;
    public nome: string;
    public sobrenome: string;
    public email: string;
    public login: string;
    public senha: string;
    public bloqueado: boolean;
    public notificar: boolean;
    public teste: boolean;
    public OutroTeste: Date;
    public linkImage: string;
    public admin: boolean;
    public tipoAcesso: string;
    private token: string;
    private departamento: string;

    constructor(id?:string, codigo?: number, nome?: string, email?: string, sobrenome?: string, login?: string, token?: string, bloqueado?: boolean, notificar?: boolean,linkImage?: string, departamento?: string, admin?: boolean, tipoAcesso?: string) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.sobrenome = sobrenome;
        this.email = email;
        this.bloqueado = bloqueado;
        this.notificar = notificar;
        this.login = login;
        this.linkImage = linkImage;
        this.token = token;
        this.departamento = departamento;
        this.admin = admin;
        this.tipoAcesso = tipoAcesso;
    }

    get Token() {
        return this.token;
    }

}
